import axios from "axios"
import { storage } from "@/utils/storage";
import router from '@/router'
import store from '@/store'
import vue from '@/main.js'
import { Message } from 'element-ui'
import unloadList from '@/common/unload_list'

// 开发端口 9002 ，发布端口 8083
// export const baseURL = "https://192.168.18.106:8083"
// export const baseURL = 'http://221.5.19.14:8103'
export const baseURL = 'https://www.zlo.com.cn' // 远程服务器:发布
// export const baseURL = 'https://www.zlo.com.cn:9002' // 远程服务器:测试
// export const baseURL = 'http://192.168.1.17:9002' // 本地开发测试 浩
// export const baseURL = 'http://127.0.0.1:8083' // 本地开发测试 浩
// export const baseURL = 'http://8.134.11.3:8083' // 本地开发测试 浩

// export const websocketIP = '127.0.0.1' // websocket IP // 远程
// export const websocketIP = '8.134.11.3' // websocket IP // 本地
export const websocketIP = 'www.zlo.com.cn' // websocket IP // 远程
// export const websocketIP = '192.168.1.9' // websocket IP // 本地

// cardBaseURL是以前学生卡相关功能与其他功能需要使用不同的域名而存在的，现在已经不需要了
// export const cardBaseURL = 'https://www.zlo.com.cn:8083' // 远程服务器(电子学生证接口):发布
// 
// 导出一个函数request，用于请求接口
export function request(config) {
  // 创建一个axios实例，设置基础URL，超时时间，上传进度回调函数
  const instance = axios.create({
    baseURL,
    timeout: 20000,
    onUploadProgress: progressEvent => {
      let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
      // console.log(complete)
    }
  })

  // 请求拦截器，在请求发送之前设置请求头
  instance.interceptors.request.use(con => {
    if (unloadList.indexOf(con.url) == -1) {
      // 调接口返回之前页面加载
      // vue.$eventBus.$emit('setLoading', true)
    }
    con.headers['bbfAdminTeacherToken'] = window.localStorage.getItem('bbfAdminTeacherToken') || ''; // 默认token
    if (window.localStorage.getItem('local_userInfo')) {
      let localUserInfo;
      const userInfoString = window.localStorage.getItem('local_userInfo');

      // 确保获取到的字符串不为空或未定义
      if (userInfoString) {
        try {
          localUserInfo = JSON.parse(userInfoString);
        } catch (e) {
          console.error("Failed to parse local_userInfo from localStorage:", e);
          // 在解析失败的情况下，可以选择设置默认值或直接返回
          localUserInfo = {};
        }

        // 安全地从 parsed 对象中获取 accessToken 和 refreshToken
        con.headers['accessToken'] = localUserInfo.accessToken || '';
        con.headers['refreshToken'] = localUserInfo.refreshToken || '';
      } else {
        console.warn("local_userInfo in localStorage is empty or undefined.");
        con.headers['accessToken'] = '';
        con.headers['refreshToken'] = '';
      }
    } else {
      console.warn("local_userInfo not found in localStorage.");
      con.headers['accessToken'] = '';
      con.headers['refreshToken'] = '';
    };
    return con
  }, err => {
    vue.$eventBus.$emit('setLoading', false)
    // console.log(err)
  })

  // 响应拦截器，在响应返回之后设置加载状态
  instance.interceptors.response.use(res => {
    vue.$eventBus.$emit('setLoading', false)
    const data = res.data
    // console.log("res.data1==>", data)
    if (data.code != 200) {
      console.log(data)
    }
    switch (data.code) {
      case 1403:
        // Message.error("暂无权限，请联系管理员！")
        break;
      case 401:
        // 没有权限，重新登录
        // Message.error('获取用户信息失败，请稍后重新登录')
        // store.dispatch('user/resetToken')
        // router.replace({
        //   path: 'login',
        //   query: { redirect: router.currentRoute.fullPath }
        // })
        break;
      case 403:
        // token失效
        // Message.error('获取用户信息失败，请稍后重新登录')
        // Message.error(data.msg)
        // Message.error('获取用户信息失败，请稍后重新登录')
        // store.dispatch('user/resetToken')
        // router.replace({
        //   path: 'login',
        //   query: { redirect: router.currentRoute.fullPath }
        // })
        break;
    }
    return data
  }, err => {
    vue.$eventBus.$emit('setLoading', false)
    console.log(err)
  })

  // 返回请求结果
  return instance(config)
}

// export function cardRequest(config) {
//   const cardInstance = axios.create({
//     baseURL: cardBaseURL,
//     timeout: 20000,
//     onUploadProgress: progressEvent => {
//       let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
//       // console.log(complete)
//     }
//   })

//   cardInstance.interceptors.request.use(con => {
//     if (unloadList.indexOf(con.url) == -1) {
//       vue.$eventBus.$emit('setLoading', true)
//     }
//     con.headers['bbfAdminTeacherToken'] = window.localStorage.getItem('bbfAdminTeacherToken') || ''
//     return con
//   }, err => {
//     vue.$eventBus.$emit('setLoading', false)
//     // console.log(err)
//   })

//   cardInstance.interceptors.response.use(res => {
//     vue.$eventBus.$emit('setLoading', false)
//     const data = res.data
//     // console.log("res.data==》",res.data)
//     if (data.code != 200) {
//       console.log(data)
//     }
//     switch (data.code) {
//       case 1403:
//         // Message.error("暂无权限，请联系管理员！")
//         break;
//       case 401:
//         // 没有权限，重新登录
//         // Message.error('获取用户信息失败，请稍后重新登录')
//         Message.error(data.msg)
//         // store.dispatch('user/resetToken')
//         // router.replace({
//         //   path: 'login',
//         //   query: { redirect: router.currentRoute.fullPath }
//         // })
//         break;
//       case 403:
//         // token失效
//         // Message.error('获取用户信息失败，请稍后重新登录')
//         Message.error(data.msg)
//         // store.dispatch('user/resetToken')
//         // router.replace({
//         //   path: 'login',
//         //   query: { redirect: router.currentRoute.fullPath }
//         // })
//         break;
//     }
//     return data
//   }, err => {
//     vue.$eventBus.$emit('setLoading', false)
//     console.log(err)
//   })

//   return cardInstance(config)
// }